// Copyright 2020-2022 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: Apache-2.0
var _a;
import { notification as antdNotification } from 'antd';
import { COLORS } from '../../utilities';
var borderColorMapping = (_a = {},
    _a['info'] = COLORS.primary,
    _a['success'] = COLORS.success,
    _a['error'] = COLORS.error,
    _a);
export var openNotification = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'info' : _b, _c = _a.title, title = _c === void 0 ? 'Notification' : _c, description = _a.description, className = _a.className, _d = _a.duration, duration = _d === void 0 ? 30 : _d;
    antdNotification[type]({
        message: title,
        description: description,
        style: {
            borderBottom: "4px solid ".concat(borderColorMapping[type]),
            overflow: 'scroll',
        },
        duration: duration,
        className: className,
    });
};
